import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';

import {
  FHAntdDateTimePicker,
  FAntdTimePicker,
  FHButton,
  FBoxContainer,
} from '../../../../../../base';
import { applyTimeToDate, disabledFutureDate } from '../../../../../../../helpers';
import { FORTA_WHITE } from '../../../../../../../utils/colors';
import { BackgroundTypes } from '../../../../../../../constants';

import type { Moment } from 'moment';
import type { IParentSupervision } from '../../../../../../../utils/types';

interface BackdateFormProps {
  parentSupervision: IParentSupervision | null;
  onBackdate: (backdatedDate: Moment, utcOffset: number | null) => void;
}

function BackdateForm({ parentSupervision, onBackdate }: BackdateFormProps) {
  const [backdatedDate, setBackdatedDate] = useState<Moment | null>(null);
  const [utcOffsetForBackdate, setUtcOffsetForBackdate] = useState<number | null>(null);

  useEffect(() => {
    if (!parentSupervision) return;
    setBackdatedDate(moment(parentSupervision.date_start));
    setUtcOffsetForBackdate(parentSupervision.utc_offset_date_start ?? null);
  }, [parentSupervision]);

  const handleDateChange = (value: Moment | null) => {
    if (value) setBackdatedDate(value);
  };

  const handleBackdateClick = () => {
    if (backdatedDate) {
      onBackdate(backdatedDate, utcOffsetForBackdate);
    }
  };

  const handleTimeChange = (value: Moment | null) => {
    if (value && backdatedDate) {
      setBackdatedDate(applyTimeToDate(backdatedDate, value));
    }
  };

  return (
    <FBoxContainer
      sx={{
        flex: 1,
        borderRadius: '8px',
        backgroundColor: FORTA_WHITE,
        boxShadow: 'none',
        mb: 2,
      }}
      headerStyle={{
        background: 'transparent',
        borderRadius: 0,
        boxShadow: 'none',
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
        }}
      >
        <Box mr={3}>
          <FHAntdDateTimePicker
            format="MM/DD/YY"
            inputHeight={40}
            sx={{ boxShadow: 'none' }}
            BackgroundTypes={BackgroundTypes.Colored}
            inputReadOnly
            allowClear={false}
            value={backdatedDate}
            disabledDate={disabledFutureDate}
            onSelect={handleDateChange}
            onChange={handleDateChange}
          />
        </Box>
        <FAntdTimePicker
          inputHeight={40}
          style={{
            boxShadow: 'none',
            backgroundColor: FORTA_WHITE,
          }}
          format="h:mm A"
          allowClear={false}
          showNow
          use12Hours
          coloredBackground
          value={backdatedDate}
          onChange={handleTimeChange}
          onSelect={handleTimeChange}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', ml: 3 }}>
          <FHButton onClick={handleBackdateClick}>Backdate Note</FHButton>
        </Box>
      </Box>
    </FBoxContainer>
  );
}

export default BackdateForm;
